import { buildInitialValues } from '../helpers'
import type { LastCommentWidgetSettings } from './lastCommentWidgetSettingsSchema'
const DEFAULT_FONT_COLOR = 'ffffff'
const DEFAULT_COMMENT_FONT_COLOR = '9ECB0A'
const DEFAULT_FONT = 'Fira Sans'
const DEFAULT_FONT_WEIGHT = 400
const BOLD_FONT_WEIGHT = 700
const DEFAULT_FONT_SIZE = 18

const defaultValues = {
  darkMode: true,
  textAlign: 'center',
  displayNumber: 1,

  headlineFont: DEFAULT_FONT,
  headlineFontWeight: BOLD_FONT_WEIGHT,
  headlineFontSize: 32,
  headlineFontColor: DEFAULT_FONT_COLOR,
  headlineText: 'Kommentar der Spender*in',

  dataFont: DEFAULT_FONT,
  dataFontWeight: DEFAULT_FONT_WEIGHT,
  dataFontSize: DEFAULT_FONT_SIZE,
  dataFontColor: DEFAULT_FONT_COLOR,

  screenNameFont: DEFAULT_FONT,
  screenNameFontWeight: DEFAULT_FONT_WEIGHT,
  screenNameFontSize: DEFAULT_FONT_SIZE,
  screenNameFontColor: DEFAULT_FONT_COLOR,

  commentFont: DEFAULT_FONT,
  commentFontWeight: BOLD_FONT_WEIGHT,
  commentFontSize: 24,
  commentFontColor: DEFAULT_COMMENT_FONT_COLOR,
} satisfies LastCommentWidgetSettings

const getDefaultValues = buildInitialValues(defaultValues as LastCommentWidgetSettings)

export default getDefaultValues
